import { useState } from 'react';
import { useParams, Link } from 'react-router-dom';

interface Post {
  id: number;
  images: string[];
  content: string;
  level: number;
  levelName: string;
  likes: number;
  comments: number;
  createdAt: string;
}

interface SubscriptionLevel {
  level: number;
  name: string;
  price: number;
  benefits: string[];
}

interface Message {
  id: number;
  text: string;
  sender: 'me' | 'creator';
  time: string;
  isRead: boolean;
}

export default function CreatorDetail() {
  const { id } = useParams();
  const [showSubscribeModal, setShowSubscribeModal] = useState(false);
  const [selectedLevel, setSelectedLevel] = useState(1);
  const [showTipModal, setShowTipModal] = useState(false);
  const [tipAmount, setTipAmount] = useState('');
  const [tipMessage, setTipMessage] = useState('');
  const [showMessageModal, setShowMessageModal] = useState(false);
  const [showChatModal, setShowChatModal] = useState(false);
  const [messageText, setMessageText] = useState('');
  const [chatText, setChatText] = useState('');
  const [isRecommended, setIsRecommended] = useState(false);
  const [recommendCount, setRecommendCount] = useState(3456);
  const [showPostModal, setShowPostModal] = useState(false);
  const [selectedPost, setSelectedPost] = useState<Post | null>(null);
  const [postLikes, setPostLikes] = useState<{ [key: number]: boolean }>({});
  const [postSaves, setPostSaves] = useState<{ [key: number]: boolean }>({});
  const [postComments, setPostComments] = useState<{ [key: number]: Array<{ id: number; user: string; text: string; time: string }> }>({
    1: [
      { id: 1, user: '지수', text: '너무 예뻐요! 💕', time: '1시간 전' },
      { id: 2, user: '민수', text: '오늘도 좋은 콘텐츠 감사합니다!', time: '30분 전' }
    ]
  });
  const [newComment, setNewComment] = useState('');

  const balance = 125;
  const quickTipAmounts = [1, 3, 5, 10, 30, 100];

  // Mock data - 실제로는 API에서 가져옴
  const creator = {
    id: Number(id),
    name: '민지',
    avatar: 'https://public.readdy.ai/ai/img_res/f548c036cf6a549d0fd84896797a261c.jpg',
    cover: 'https://readdy.ai/api/search-image?query=soft%20pastel%20pink%20purple%20gradient%20abstract%20background%20with%20sparkles%20dreamy%20aesthetic%20smooth%20texture%20elegant%20minimalist%20design&width=1200&height=400&seq=creator1cover&orientation=landscape',
    category: '일상/브이로그',
    subscribers: 1250,
    bio: '안녕하세요! 일상과 여행을 공유하는 민지입니다 💕 함께 즐거운 시간 보내요!',
    isSubscribed: true,
    currentLevel: 2
  };

  const chatMessages: Message[] = [
    { id: 1, text: '안녕하세요! 항상 응원합니다 💕', sender: 'me', time: '오전 10:30', isRead: true },
    { id: 2, text: '감사합니다! 앞으로도 좋은 콘텐츠로 보답할게요!', sender: 'creator', time: '오전 10:35', isRead: true },
    { id: 3, text: '다음 콘텐츠 언제 올라오나요?', sender: 'me', time: '오후 2:20', isRead: true },
    { id: 4, text: '이번 주말에 올릴 예정이에요 😊', sender: 'creator', time: '오후 2:25', isRead: true },
  ];

  const [messages, setMessages] = useState<Message[]>(chatMessages);

  const subscriptionLevels: SubscriptionLevel[] = [
    {
      level: 1,
      name: '베이직',
      price: 10,
      benefits: ['기본 콘텐츠 열람', '월 10개 이상 포스트', '커뮤니티 참여']
    },
    {
      level: 2,
      name: '스탠다드',
      price: 20,
      benefits: ['레벨 1 혜택 포함', '독점 사진 콘텐츠', '월 20개 이상 포스트', '우선 댓글 답변']
    },
    {
      level: 3,
      name: '프리미엄',
      price: 40,
      benefits: ['레벨 2 혜택 포함', '독점 영상 콘텐츠', '월 30개 이상 포스트', '1:1 메시지 가능']
    },
    {
      level: 4,
      name: 'VIP',
      price: 80,
      benefits: ['레벨 3 혜택 포함', '비하인드 콘텐츠', '무제한 포스트', '영상 통화 이벤트 참여']
    },
    {
      level: 5,
      name: '다이아몬드',
      price: 150,
      benefits: ['모든 혜택 포함', '개인 맞춤 콘텐츠', '월 1회 화상 팬미팅', '생일 축하 영상']
    }
  ];

  const posts: Post[] = [
    {
      id: 1,
      images: [
        'https://readdy.ai/api/search-image?query=korean%20female%20lifestyle%20blogger%20casual%20daily%20outfit%20mirror%20selfie%20bright%20natural%20lighting%20cozy%20bedroom%20aesthetic%20simple%20clean%20background&width=400&height=500&seq=post1&orientation=portrait',
        'https://readdy.ai/api/search-image?query=korean%20female%20lifestyle%20vlogger%20coffee%20shop%20aesthetic%20latte%20art%20cozy%20cafe%20interior%20warm%20lighting%20minimalist%20simple%20background&width=400&height=500&seq=post1b&orientation=portrait'
      ],
      content: '오늘의 일상 💕 카페에서 작업하는 중이에요!',
      level: 1,
      levelName: '베이직',
      likes: 234,
      comments: 45,
      createdAt: '2시간 전'
    },
    {
      id: 2,
      images: [
        'https://readdy.ai/api/search-image?query=korean%20female%20content%20creator%20exclusive%20photoshoot%20professional%20studio%20lighting%20elegant%20pose%20pink%20purple%20aesthetic%20simple%20clean%20background&width=400&height=500&seq=post2&orientation=portrait'
      ],
      content: '독점 화보 공개! 여러분만을 위한 특별한 사진이에요 ✨',
      level: 2,
      levelName: '스탠다드',
      likes: 567,
      comments: 89,
      createdAt: '5시간 전'
    },
    {
      id: 3,
      images: [
        'https://readdy.ai/api/search-image?query=korean%20female%20vlogger%20behind%20the%20scenes%20video%20thumbnail%20filming%20setup%20professional%20camera%20equipment%20studio%20aesthetic%20simple%20background&width=400&height=500&seq=post3&orientation=portrait'
      ],
      content: '비하인드 영상! 촬영 현장의 모습을 담았어요 🎬',
      level: 3,
      levelName: '프리미엄',
      likes: 892,
      comments: 156,
      createdAt: '1일 전'
    },
    {
      id: 4,
      images: [
        'https://readdy.ai/api/search-image?query=korean%20female%20creator%20vip%20exclusive%20content%20special%20photoshoot%20luxury%20aesthetic%20elegant%20lighting%20premium%20quality%20simple%20clean%20background&width=400&height=500&seq=post4&orientation=portrait'
      ],
      content: 'VIP 회원님들을 위한 특별한 선물 🎁',
      level: 4,
      levelName: 'VIP',
      likes: 1234,
      comments: 234,
      createdAt: '2일 전'
    },
    {
      id: 5,
      images: [
        'https://readdy.ai/api/search-image?query=korean%20female%20content%20creator%20diamond%20tier%20exclusive%20premium%20photoshoot%20luxurious%20aesthetic%20professional%20lighting%20high%20quality%20simple%20elegant%20background&width=400&height=500&seq=post5&orientation=portrait'
      ],
      content: '다이아몬드 회원님들만의 초특급 콘텐츠 💎',
      level: 5,
      levelName: '다이아몬드',
      likes: 1567,
      comments: 312,
      createdAt: '3일 전'
    },
    {
      id: 6,
      images: [
        'https://readdy.ai/api/search-image?query=korean%20female%20lifestyle%20blogger%20daily%20routine%20morning%20coffee%20breakfast%20aesthetic%20natural%20lighting%20cozy%20home%20interior%20simple%20clean%20background&width=400&height=500&seq=post6&orientation=portrait'
      ],
      content: '굿모닝! 오늘도 좋은 하루 보내세요 ☀️',
      level: 1,
      levelName: '베이직',
      likes: 445,
      comments: 67,
      createdAt: '3일 전'
    }
  ];

  const handleSubscribe = () => {
    alert(`${subscriptionLevels[selectedLevel - 1].name} 레벨 구독이 완료되었습니다!`);
    setShowSubscribeModal(false);
  };

  const handleSendTip = () => {
    if (!tipAmount || Number(tipAmount) < 1) {
      alert('최소 후원 금액은 1피치입니다.');
      return;
    }
    if (Number(tipAmount) > balance) {
      alert('잔액이 부족합니다. 충전 후 이용해주세요.');
      return;
    }
    alert(`${Number(tipAmount).toLocaleString()}피치 후원이 완료되었습니다! 💝`);
    setShowTipModal(false);
    setTipAmount('');
    setTipMessage('');
  };

  const handleSendMessage = () => {
    if (!messageText.trim()) {
      alert('메시지를 입력해주세요.');
      return;
    }
    alert('메시지가 전송되었습니다! 💌');
    setShowMessageModal(false);
    setMessageText('');
  };

  const handleSendChat = () => {
    if (!chatText.trim()) return;
    
    const newMessage: Message = {
      id: Date.now(),
      text: chatText,
      sender: 'me',
      time: '방금 전',
      isRead: false
    };
    
    setMessages([...messages, newMessage]);
    setChatText('');
  };

  const handleMessageClick = () => {
    if (creator.isSubscribed) {
      setShowChatModal(true);
    } else {
      setShowMessageModal(true);
    }
  };

  const handleRecommend = () => {
    if (isRecommended) {
      setIsRecommended(false);
      setRecommendCount(recommendCount - 1);
      alert('추천을 취소했습니다.');
    } else {
      setIsRecommended(true);
      setRecommendCount(recommendCount + 1);
      alert('크리에이터를 추천했습니다! 💖');
    }
  };

  const handlePostClick = (post: Post) => {
    const isLocked = post.level > creator.currentLevel;
    if (isLocked) {
      setShowSubscribeModal(true);
    } else {
      setSelectedPost(post);
      setShowPostModal(true);
    }
  };

  const handlePostLike = (postId: number) => {
    setPostLikes(prev => ({
      ...prev,
      [postId]: !prev[postId]
    }));
  };

  const handlePostSave = (postId: number) => {
    setPostSaves(prev => ({
      ...prev,
      [postId]: !prev[postId]
    }));
  };

  const handleAddComment = () => {
    if (!newComment.trim() || !selectedPost) return;
    
    const comment = {
      id: Date.now(),
      user: '나',
      text: newComment,
      time: '방금 전'
    };
    
    setPostComments(prev => ({
      ...prev,
      [selectedPost.id]: [...(prev[selectedPost.id] || []), comment]
    }));
    
    setNewComment('');
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-white via-pink-50 to-purple-50 pb-20 md:pb-8">
      {/* Top Navigation */}
      <nav className="sticky top-0 z-50 bg-white/80 backdrop-blur-md border-b border-pink-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <Link to="/fan/dashboard" className="flex items-center gap-2 text-gray-600 hover:text-pink-500">
              <i className="ri-arrow-left-line text-xl"></i>
              <span className="font-medium">뒤로</span>
            </Link>
            <div className="text-xl font-black bg-gradient-to-r from-pink-500 via-purple-500 to-blue-500 bg-clip-text text-transparent">
              MyFanHub
            </div>
            <Link
              to="/fan/wallet"
              className="flex items-center gap-2 px-3 py-1.5 bg-gradient-to-r from-pink-100 to-purple-100 rounded-full hover:from-pink-200 hover:to-purple-200 transition-all"
            >
              <i className="ri-wallet-3-line text-pink-600"></i>
              <span className="font-semibold text-gray-800 text-sm">125개 🍑</span>
            </Link>
          </div>
        </div>
      </nav>

      {/* Cover Image */}
      <div className="relative h-64 w-full overflow-hidden">
        <img
          src={creator.cover}
          alt={creator.name}
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/40"></div>
      </div>

      {/* Creator Info */}
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 -mt-20 relative z-10">
        <div className="bg-white rounded-3xl shadow-xl p-6 mb-6">
          <div className="flex flex-col md:flex-row items-start md:items-center gap-6">
            {/* Avatar */}
            <div className="w-32 h-32 rounded-full overflow-hidden border-4 border-white shadow-lg">
              <img
                src={creator.avatar}
                alt={creator.name}
                className="w-full h-full object-cover"
              />
            </div>

            {/* Info */}
            <div className="flex-1">
              <div className="flex items-start justify-between mb-3">
                <div>
                  <h1 className="text-3xl font-bold text-gray-800 mb-2">{creator.name}</h1>
                  <p className="text-gray-600 mb-1">{creator.category}</p>
                  <div className="flex items-center gap-4 text-sm text-gray-500">
                    <span className="flex items-center gap-1">
                      <i className="ri-user-3-line"></i>
                      구독자 {creator.subscribers.toLocaleString()}명
                    </span>
                    <span className="flex items-center gap-1">
                      <i className={`${isRecommended ? 'ri-heart-3-fill text-pink-500' : 'ri-heart-3-line'}`}></i>
                      추천 {recommendCount.toLocaleString()}
                    </span>
                  </div>
                </div>
              </div>
              <p className="text-gray-700 mb-4">{creator.bio}</p>
              
              {/* Action Buttons */}
              <div className="flex flex-col gap-3">
                {/* Subscribe Status or Subscribe Button */}
                {!creator.isSubscribed ? (
                  <button
                    onClick={() => setShowSubscribeModal(true)}
                    className="px-8 py-3 bg-gradient-to-r from-pink-500 to-purple-500 text-white rounded-full font-semibold hover:shadow-lg transition-all whitespace-nowrap w-fit"
                  >
                    <i className="ri-heart-3-line mr-2"></i>
                    구독하기
                  </button>
                ) : (
                  <div className="px-6 py-3 bg-gradient-to-r from-pink-100 to-purple-100 text-pink-600 rounded-full font-semibold w-fit">
                    <i className="ri-heart-3-fill mr-2"></i>
                    {subscriptionLevels[creator.currentLevel - 1]?.name} 구독 중
                  </div>
                )}

                {/* Action Buttons Row - 구독 중일 때만 표시 */}
                {creator.isSubscribed && (
                  <div className="flex flex-col sm:flex-row flex-wrap items-stretch sm:items-center gap-3">
                    {/* Level Change Button */}
                    <button
                      onClick={() => setShowSubscribeModal(true)}
                      className="flex-1 sm:flex-none px-6 py-3 border-2 border-pink-300 text-pink-600 rounded-full font-semibold hover:bg-pink-50 transition-all whitespace-nowrap"
                    >
                      <i className="ri-vip-crown-line mr-2"></i>
                      레벨 변경
                    </button>

                    {/* Tip Button */}
                    <button
                      onClick={() => setShowTipModal(true)}
                      className="flex-1 sm:flex-none px-6 py-3 bg-white border-2 border-purple-300 text-purple-600 rounded-full font-semibold hover:bg-purple-50 transition-all whitespace-nowrap"
                    >
                      <i className="ri-gift-line mr-2"></i>
                      후원하기
                    </button>

                    {/* Message Button */}
                    <button
                      onClick={handleMessageClick}
                      className="flex-1 sm:flex-none px-6 py-3 bg-white border-2 border-gray-300 text-gray-700 rounded-full font-semibold hover:bg-gray-50 transition-all whitespace-nowrap"
                    >
                      <i className="ri-message-3-line mr-2"></i>
                      메시지
                    </button>

                    {/* Recommend Button */}
                    <button
                      onClick={handleRecommend}
                      className={`flex-1 sm:flex-none px-6 py-3 border-2 rounded-full font-semibold transition-all whitespace-nowrap ${
                        isRecommended
                          ? 'border-pink-500 bg-pink-50 text-pink-600'
                          : 'border-gray-300 bg-white text-gray-700 hover:bg-gray-50'
                      }`}
                    >
                      <i className={`${isRecommended ? 'ri-heart-3-fill' : 'ri-heart-3-line'} mr-2`}></i>
                      추천하기
                    </button>
                  </div>
                )}

                {/* Action Buttons for Non-Subscribers */}
                {!creator.isSubscribed && (
                  <div className="flex flex-col sm:flex-row flex-wrap items-stretch sm:items-center gap-3">
                    {/* Tip Button */}
                    <button
                      onClick={() => setShowTipModal(true)}
                      className="flex-1 sm:flex-none px-6 py-3 bg-white border-2 border-purple-300 text-purple-600 rounded-full font-semibold hover:bg-purple-50 transition-all whitespace-nowrap"
                    >
                      <i className="ri-gift-line mr-2"></i>
                      후원하기
                    </button>

                    {/* Message Button */}
                    <button
                      onClick={handleMessageClick}
                      className="flex-1 sm:flex-none px-6 py-3 bg-white border-2 border-gray-300 text-gray-700 rounded-full font-semibold hover:bg-gray-50 transition-all whitespace-nowrap"
                    >
                      <i className="ri-message-3-line mr-2"></i>
                      메시지
                    </button>

                    {/* Recommend Button */}
                    <button
                      onClick={handleRecommend}
                      className={`flex-1 sm:flex-none px-6 py-3 border-2 rounded-full font-semibold transition-all whitespace-nowrap ${
                        isRecommended
                          ? 'border-pink-500 bg-pink-50 text-pink-600'
                          : 'border-gray-300 bg-white text-gray-700 hover:bg-gray-50'
                      }`}
                    >
                      <i className={`${isRecommended ? 'ri-heart-3-fill' : 'ri-heart-3-line'} mr-2`}></i>
                      추천하기
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Posts Grid */}
        <div className="mb-6">
          <h2 className="text-2xl font-bold text-gray-800 mb-4">콘텐츠</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {posts.map((post) => {
              const isLocked = post.level > creator.currentLevel;
              
              return (
                <div
                  key={post.id}
                  onClick={() => handlePostClick(post)}
                  className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-lg transition-all group cursor-pointer"
                >
                  {/* Image */}
                  <div className="relative aspect-[4/5] overflow-hidden">
                    <img
                      src={post.images[0]}
                      alt="Post"
                      className={`w-full h-full object-cover group-hover:scale-105 transition-transform ${
                        isLocked ? 'blur-xl' : ''
                      }`}
                    />
                    {post.images.length > 1 && !isLocked && (
                      <div className="absolute top-3 right-3 px-2 py-1 bg-black/60 text-white text-xs rounded-full flex items-center gap-1">
                        <i className="ri-image-line"></i>
                        <span>{post.images.length}</span>
                      </div>
                    )}
                    
                    {/* Lock Overlay */}
                    {isLocked && (
                      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/70 flex flex-col items-center justify-center text-white">
                        <i className="ri-lock-fill text-5xl mb-3"></i>
                        <p className="font-bold text-lg mb-2">{post.levelName} 이상 필요</p>
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            setShowSubscribeModal(true);
                          }}
                          className="px-6 py-2 bg-white text-pink-600 rounded-full font-semibold hover:bg-pink-50 transition-all whitespace-nowrap"
                        >
                          구독하기
                        </button>
                      </div>
                    )}
                  </div>

                  {/* Content */}
                  {!isLocked && (
                    <div className="p-4">
                      <p className="text-gray-800 mb-3 line-clamp-2">{post.content}</p>
                      <div className="flex items-center justify-between text-sm text-gray-500">
                        <div className="flex items-center gap-4">
                          <span className="flex items-center gap-1">
                            <i className="ri-heart-3-line"></i>
                            {post.likes}
                          </span>
                          <span className="flex items-center gap-1">
                            <i className="ri-chat-3-line"></i>
                            {post.comments}
                          </span>
                        </div>
                        <span>{post.createdAt}</span>
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {/* Post Detail Modal */}
      {showPostModal && selectedPost && (
        <div className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-3xl max-w-5xl w-full max-h-[90vh] overflow-hidden flex flex-col md:flex-row">
            {/* Image Section */}
            <div className="md:w-3/5 bg-black flex items-center justify-center relative">
              <button
                onClick={() => setShowPostModal(false)}
                className="absolute top-4 right-4 w-10 h-10 bg-white/10 hover:bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center transition-all z-10 cursor-pointer"
              >
                <i className="ri-close-line text-2xl text-white"></i>
              </button>
              <img
                src={selectedPost.images[0]}
                alt="Post"
                className="w-full h-full object-contain max-h-[90vh]"
              />
            </div>

            {/* Content Section */}
            <div className="md:w-2/5 flex flex-col max-h-[90vh] md:max-h-none">
              {/* Header */}
              <div className="p-6 border-b border-gray-200">
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 rounded-full overflow-hidden">
                    <img src={creator.avatar} alt={creator.name} className="w-full h-full object-cover" />
                  </div>
                  <div>
                    <h3 className="font-bold text-gray-900">{creator.name}</h3>
                    <p className="text-sm text-gray-500">{selectedPost.createdAt}</p>
                  </div>
                </div>
              </div>

              {/* Content */}
              <div className="flex-1 overflow-y-auto p-6">
                <p className="text-gray-800 mb-6">{selectedPost.content}</p>

                {/* Comments */}
                <div className="space-y-4">
                  <h4 className="font-bold text-gray-900">댓글 {(postComments[selectedPost.id] || []).length}</h4>
                  {(postComments[selectedPost.id] || []).map((comment) => (
                    <div key={comment.id} className="flex gap-3">
                      <div className="w-8 h-8 rounded-full bg-gradient-to-r from-pink-400 to-purple-400 flex items-center justify-center text-white font-bold text-sm flex-shrink-0">
                        {comment.user[0]}
                      </div>
                      <div className="flex-1">
                        <div className="flex items-center gap-2 mb-1">
                          <span className="font-semibold text-sm text-gray-900">{comment.user}</span>
                          <span className="text-xs text-gray-500">{comment.time}</span>
                        </div>
                        <p className="text-sm text-gray-700">{comment.text}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Actions */}
              <div className="border-t border-gray-200 p-6">
                <div className="flex items-center justify-between mb-4">
                  <div className="flex items-center gap-4">
                    <button
                      onClick={() => handlePostLike(selectedPost.id)}
                      className="flex items-center gap-2 hover:text-pink-500 transition-colors cursor-pointer"
                    >
                      <i className={`text-2xl ${postLikes[selectedPost.id] ? 'ri-heart-3-fill text-pink-500' : 'ri-heart-3-line text-gray-700'}`}></i>
                      <span className="font-semibold text-gray-700">{selectedPost.likes + (postLikes[selectedPost.id] ? 1 : 0)}</span>
                    </button>
                    <button className="flex items-center gap-2 text-gray-700 hover:text-purple-500 transition-colors cursor-pointer">
                      <i className="ri-chat-3-line text-2xl"></i>
                      <span className="font-semibold">{(postComments[selectedPost.id] || []).length}</span>
                    </button>
                  </div>
                  <button
                    onClick={() => handlePostSave(selectedPost.id)}
                    className="hover:text-purple-500 transition-colors cursor-pointer"
                  >
                    <i className={`text-2xl ${postSaves[selectedPost.id] ? 'ri-bookmark-fill text-purple-500' : 'ri-bookmark-line text-gray-700'}`}></i>
                  </button>
                </div>

                {/* Comment Input */}
                <div className="flex items-center gap-3">
                  <input
                    type="text"
                    value={newComment}
                    onChange={(e) => setNewComment(e.target.value)}
                    placeholder="댓글을 입력하세요..."
                    className="flex-1 px-4 py-2 border border-gray-300 rounded-full focus:outline-none focus:border-pink-500 text-sm"
                    onKeyPress={(e) => {
                      if (e.key === 'Enter') {
                        handleAddComment();
                      }
                    }}
                  />
                  <button
                    onClick={handleAddComment}
                    disabled={!newComment.trim()}
                    className="px-6 py-2 bg-gradient-to-r from-pink-500 to-purple-500 text-white rounded-full font-semibold hover:shadow-lg transition-all disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
                  >
                    게시
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Subscribe Modal */}
      {showSubscribeModal && (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-3xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
            <div className="sticky top-0 bg-white border-b border-gray-100 p-6 flex items-center justify-between">
              <h2 className="text-2xl font-bold text-gray-800">구독 레벨 선택</h2>
              <button
                onClick={() => setShowSubscribeModal(false)}
                className="w-10 h-10 rounded-full hover:bg-gray-100 flex items-center justify-center transition-colors"
              >
                <i className="ri-close-line text-2xl text-gray-600"></i>
              </button>
            </div>

            <div className="p-6 space-y-4">
              {subscriptionLevels.map((level) => (
                <div
                  key={level.level}
                  onClick={() => setSelectedLevel(level.level)}
                  className={`p-6 rounded-2xl border-2 cursor-pointer transition-all ${
                    selectedLevel === level.level
                      ? 'border-pink-500 bg-gradient-to-r from-pink-50 to-purple-50'
                      : 'border-gray-200 hover:border-pink-300'
                  }`}
                >
                  <div className="flex items-start justify-between mb-4">
                    <div>
                      <h3 className="text-xl font-bold text-gray-800 mb-1">{level.name}</h3>
                      <p className="text-2xl font-bold text-pink-600">{level.price.toLocaleString()}피치/월</p>
                    </div>
                    <div
                      className={`w-6 h-6 rounded-full border-2 flex items-center justify-center ${
                        selectedLevel === level.level
                          ? 'border-pink-500 bg-pink-500'
                          : 'border-gray-300'
                      }`}
                    >
                      {selectedLevel === level.level && (
                        <i className="ri-check-line text-white text-sm"></i>
                      )}
                    </div>
                  </div>
                  <ul className="space-y-2">
                    {level.benefits.map((benefit, index) => (
                      <li key={index} className="flex items-start gap-2 text-gray-700">
                        <i className="ri-check-line text-pink-500 mt-0.5"></i>
                        <span>{benefit}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>

            <div className="sticky bottom-0 bg-white border-t border-gray-100 p-6">
              <button
                onClick={handleSubscribe}
                className="w-full py-4 bg-gradient-to-r from-pink-500 to-purple-500 text-white rounded-xl font-bold text-lg hover:shadow-lg transition-all whitespace-nowrap"
              >
                {subscriptionLevels[selectedLevel - 1].price.toLocaleString()}피치로 구독하기
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Tip Modal */}
      {showTipModal && (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-3xl max-w-md w-full">
            <div className="border-b border-gray-100 p-6 flex items-center justify-between">
              <h2 className="text-2xl font-bold text-gray-800">후원하기</h2>
              <button
                onClick={() => {
                  setShowTipModal(false);
                  setTipAmount('');
                  setTipMessage('');
                }}
                className="w-10 h-10 rounded-full hover:bg-gray-100 flex items-center justify-center transition-colors"
              >
                <i className="ri-close-line text-2xl text-gray-600"></i>
              </button>
            </div>

            <div className="p-6">
              {/* Creator Info */}
              <div className="flex items-center gap-3 mb-6 p-4 bg-gray-50 rounded-xl">
                <div className="w-12 h-12 rounded-full overflow-hidden border border-gray-200">
                  <img
                    src={creator.avatar}
                    alt={creator.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <h3 className="font-bold text-gray-900">{creator.name}</h3>
                  <p className="text-sm text-gray-600">{creator.category}</p>
                </div>
              </div>

              {/* Balance Info */}
              <div className="mb-6 p-4 bg-gradient-to-r from-pink-50 to-purple-50 rounded-xl">
                <div className="flex items-center justify-between">
                  <span className="text-sm text-gray-600">보유 피치</span>
                  <div className="flex items-center gap-1">
                    <span className="text-lg font-bold text-gray-900">{balance.toLocaleString()}</span>
                    <span className="text-lg">🍑</span>
                  </div>
                </div>
              </div>

              {/* Quick Tip Amounts */}
              <div className="mb-6">
                <p className="text-sm font-semibold text-gray-700 mb-3">빠른 선택</p>
                <div className="grid grid-cols-3 gap-3">
                  {quickTipAmounts.map((amount) => (
                    <button
                      key={amount}
                      onClick={() => setTipAmount(amount.toString())}
                      className={`py-3 rounded-xl font-semibold transition-all whitespace-nowrap ${
                        tipAmount === amount.toString()
                          ? 'bg-gradient-to-r from-pink-500 to-purple-500 text-white'
                          : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                      }`}
                    >
                      {amount}🍑
                    </button>
                  ))}
                </div>
              </div>

              {/* Custom Amount */}
              <div className="mb-6">
                <p className="text-sm font-semibold text-gray-700 mb-3">직접 입력</p>
                <div className="relative">
                  <input
                    type="number"
                    value={tipAmount}
                    onChange={(e) => setTipAmount(e.target.value)}
                    placeholder="후원 피치 입력"
                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-pink-500 focus:outline-none text-lg"
                  />
                  <span className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-500 font-semibold">🍑</span>
                </div>
                <p className="text-xs text-gray-500 mt-2">최소 후원: 1피치</p>
              </div>

              {/* Tip Message */}
              <div className="mb-6">
                <p className="text-sm font-semibold text-gray-700 mb-3">응원 메시지 (선택)</p>
                <textarea
                  value={tipMessage}
                  onChange={(e) => setTipMessage(e.target.value)}
                  placeholder="크리에이터에게 전할 메시지를 입력하세요..."
                  className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-pink-500 focus:outline-none resize-none"
                  rows={3}
                  maxLength={200}
                />
                <p className="text-xs text-gray-500 mt-2">{tipMessage.length}/200</p>
              </div>

              {/* Send Button */}
              <button
                onClick={handleSendTip}
                disabled={!tipAmount || Number(tipAmount) < 1}
                className="w-full py-4 bg-gradient-to-r from-pink-500 to-purple-500 text-white rounded-xl font-bold text-lg hover:shadow-lg transition-all disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap"
              >
                {tipAmount ? `${Number(tipAmount).toLocaleString()}피치 후원하기` : '금액을 입력하세요'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Chat Modal (구독자용) */}
      {showChatModal && (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-3xl max-w-2xl w-full h-[80vh] flex flex-col">
            {/* 헤더 */}
            <div className="flex items-center justify-between p-6 border-b border-gray-200">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 rounded-full overflow-hidden">
                  <img src={creator.avatar} alt={creator.name} className="w-full h-full object-cover" />
                </div>
                <div>
                  <h3 className="text-lg font-bold text-gray-800">{creator.name}</h3>
                  <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-gradient-to-r from-pink-400 to-purple-400 text-white text-xs font-semibold">
                    <i className="ri-vip-crown-fill"></i>
                    {subscriptionLevels[creator.currentLevel - 1]?.name}
                  </span>
                </div>
              </div>
              <button
                onClick={() => setShowChatModal(false)}
                className="w-10 h-10 rounded-full hover:bg-gray-100 flex items-center justify-center transition-all cursor-pointer"
              >
                <i className="ri-close-line text-2xl text-gray-600"></i>
              </button>
            </div>

            {/* 메시지 영역 */}
            <div className="flex-1 overflow-y-auto p-6 space-y-4">
              {messages.map((message) => (
                <div
                  key={message.id}
                  className={`flex ${message.sender === 'me' ? 'justify-end' : 'justify-start'}`}
                >
                  <div className={`max-w-[70%] ${message.sender === 'me' ? 'order-2' : 'order-1'}`}>
                    <div
                      className={`px-4 py-2 rounded-2xl ${
                        message.sender === 'me'
                          ? 'bg-gradient-to-r from-pink-500 to-purple-500 text-white'
                          : 'bg-gray-100 text-gray-800'
                      }`}
                    >
                      <p className="text-sm">{message.text}</p>
                    </div>
                    <div className={`flex items-center gap-1 mt-1 text-xs text-gray-500 ${message.sender === 'me' ? 'justify-end' : 'justify-start'}`}>
                      <span>{message.time}</span>
                      {message.sender === 'me' && (
                        <i className={`${message.isRead ? 'ri-check-double-line text-pink-500' : 'ri-check-line'}`}></i>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* 메시지 입력 */}
            <div className="p-6 border-t border-gray-200">
              <div className="flex items-end gap-3">
                <div className="flex flex-col gap-2">
                  <button className="w-10 h-10 flex items-center justify-center hover:bg-gray-100 rounded-full transition-colors flex-shrink-0 cursor-pointer">
                    <i className="ri-image-add-line text-xl text-gray-600"></i>
                  </button>
                  <button
                    onClick={() => {
                      setShowChatModal(false);
                      setShowTipModal(true);
                    }}
                    className="w-10 h-10 flex items-center justify-center hover:bg-gray-100 rounded-full transition-colors flex-shrink-0 cursor-pointer"
                  >
                    <i className="ri-gift-line text-xl text-gray-600"></i>
                  </button>
                </div>
                <div className="flex-1">
                  <textarea
                    value={chatText}
                    onChange={(e) => setChatText(e.target.value)}
                    placeholder="메시지를 입력하세요..."
                    className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:border-pink-500 resize-none text-base"
                    rows={2}
                    onKeyPress={(e) => {
                      if (e.key === 'Enter' && !e.shiftKey) {
                        e.preventDefault();
                        handleSendChat();
                      }
                    }}
                  />
                </div>
                <button
                  onClick={handleSendChat}
                  disabled={!chatText.trim()}
                  className="w-12 h-12 bg-gradient-to-r from-pink-500 to-purple-500 text-white rounded-full flex items-center justify-center hover:shadow-lg transition-all disabled:opacity-50 disabled:cursor-not-allowed flex-shrink-0 cursor-pointer"
                >
                  <i className="ri-send-plane-fill text-lg"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Message Modal (비구독자용) */}
      {showMessageModal && (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-3xl max-w-md w-full">
            <div className="border-b border-gray-100 p-6 flex items-center justify-between">
              <h2 className="text-2xl font-bold text-gray-800">메시지 보내기</h2>
              <button
                onClick={() => {
                  setShowMessageModal(false);
                  setMessageText('');
                }}
                className="w-10 h-10 rounded-full hover:bg-gray-100 flex items-center justify-center transition-colors"
              >
                <i className="ri-close-line text-2xl text-gray-600"></i>
              </button>
            </div>

            <div className="p-6">
              {/* Creator Info */}
              <div className="flex items-center gap-3 mb-6 p-4 bg-gray-50 rounded-xl">
                <div className="w-12 h-12 rounded-full overflow-hidden border border-gray-200">
                  <img
                    src={creator.avatar}
                    alt={creator.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <h3 className="font-bold text-gray-900">{creator.name}</h3>
                  <p className="text-sm text-gray-600">{creator.category}</p>
                </div>
              </div>

              {/* Message Input */}
              <div className="mb-6">
                <p className="text-sm font-semibold text-gray-700 mb-3">메시지 내용</p>
                <textarea
                  value={messageText}
                  onChange={(e) => setMessageText(e.target.value)}
                  placeholder="크리에이터에게 전할 메시지를 입력하세요..."
                  className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-pink-500 focus:outline-none resize-none"
                  rows={6}
                  maxLength={500}
                />
                <p className="text-xs text-gray-500 mt-2">{messageText.length}/500</p>
              </div>

              {/* Info Notice */}
              <div className="mb-6 p-4 bg-blue-50 rounded-xl">
                <div className="flex gap-3">
                  <i className="ri-information-line text-blue-600 text-xl flex-shrink-0"></i>
                  <div className="text-sm text-blue-800">
                    <p className="font-semibold mb-1">메시지 전송 안내</p>
                    <p>구독 중인 크리에이터에게만 메시지를 보낼 수 있습니다. 크리에이터의 답장은 메시지함에서 확인하실 수 있습니다.</p>
                  </div>
                </div>
              </div>

              {/* Send Button */}
              <button
                onClick={handleSendMessage}
                disabled={!messageText.trim()}
                className="w-full py-4 bg-gradient-to-r from-pink-500 to-purple-500 text-white rounded-xl font-bold text-lg hover:shadow-lg transition-all disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap"
              >
                메시지 보내기
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
